import angular from 'angular';

import Component from './weekday-viewer.component';

const Module = angular
    .module('control-room.commons.basic.components.weekday-viewer', [])
    .component('crWeekdayViewer', Component);

export default Module;
